import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Button, Icon, Heading, Table, TableCell, TableBody, TableHead, TableRow, useAuthenticator } from '@aws-amplify/ui-react';
import { s3ListFlatObjects, s3GenDownloadLink, s3WriteFile, s3DeleteFile } from '../components/s3Utils';
import { Container } from 'react-bootstrap';
// import background from '../components/assets/table-2879213_1920.jpg';
import { MdDeleteOutline } from 'react-icons/md'
import { DatumToString } from '../components/lib/DatumToString';
import { verifiedUser } from '../components/utils';

const Uploads = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const [patientenDaten, setPatientenDaten] = useState();
    const [userDaten, setUserDaten] = useState();
    const verified = verifiedUser(user);

    const IconSave = () => {
        return (
            <Icon
                ariaLabel=""
                pathData="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM19 19H5V5H16.17L19 7.83V19ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6H15V10H6V6Z"
            />
        );
    };

    const handleS3InformationList = (response) => {
        const directory = response && response.files && response.files[0] ? (response.files[0].key).split('/')[0] : '';
        //console.log('handleS3InformationList:', directory); // (response.files[0].key).split('/').pop())
        if (directory.includes('Patient'))
            setPatientenDaten([...response.files]);
        else
            setUserDaten([...response.files]);

        // console.log(response.files)
    }

    const uploadFile = (fn, data, directory) => {
        // setFileData(data);
        // console.log(fn, directory)
        s3WriteFile(directory + '/' + fn, data, 'public', 'application/pdf');
        setTimeout(() => s3ListFlatObjects(directory + '/', 'public', handleS3InformationList), 500);
    }

    const deleteFile = (fn, level, directory) => {
        // setFileData(data);
        // console.log('deleteFile:', fn, level, directory)
        s3DeleteFile(fn, level);
        setTimeout(() => s3ListFlatObjects(directory + '/', 'public', handleS3InformationList), 500);
    }

    const download = (file) => {
        // console.log(file);
        s3GenDownloadLink(file)
    }

    useEffect(() => {
        if (!userDaten) {
            // console.log('Mitarbeiter:', userDaten);
            setTimeout(() => s3ListFlatObjects("MitarbeiterInfo/", 'public', handleS3InformationList), 500);
            // s3://mys3bucket131753-default/public/MitarbeiterInfo/Personalessen naechste Woche.pdf
        }
        if (!patientenDaten) {
            // console.log('Mitarbeiter:', patientenDaten);
            setTimeout(() => s3ListFlatObjects('PatientenInfo/', 'public', handleS3InformationList), 500);
        }
        // console.log('useEffect called in Menues... isLoaded', daten, speiseplan, isLoaded)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (!user || !verified) {
        // console.log('User, verified', user, verified)
        return (<Navigate to='/profile' replace={true} />)
    }

    //    console.log('daten:', daten)
    //    style={{ backgroundImage: `url(${background})`, height:'100vh', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}>
    return (
        <Container className='left-template' >
            <>
                <Heading level={3} style={{ textAlign: "center" }} padding={20}>Informationen für Patienten</Heading>
                <Table
                    caption={`${patientenDaten ? patientenDaten.length : 0} Datei${patientenDaten ? patientenDaten.length !== 1 ? 'en' : '' : 'en'} zum Herunterladen`}
                    highlightOnHover={true}
                    size='large'
                    variation='striped'
                >
                    <TableHead>
                        <TableRow>
                            <TableCell as="th">Datei</TableCell>
                            <TableCell as="th">vom</TableCell>
                            <TableCell as="th">Größe</TableCell>
                            <TableCell as="th"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {patientenDaten && patientenDaten.map((item, i) => {
                            const theDate = DatumToString(item.lastModified);
                            return (
                                <TableRow key={`r_${i}`}>
                                    <TableCell><Button gap="0.1rem" onClick={() => download(item.key)} size="large"><IconSave /> {item.key}</Button></TableCell>
                                    <TableCell>{theDate}</TableCell>
                                    <TableCell>{item.size}</TableCell>
                                    <TableCell><Button gap="0.1rem" onClick={() => deleteFile(item.key, 'public', 'PatientenInfo')} size="large"><MdDeleteOutline /></Button></TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <p>In PatientenInfo hochladen: <input type="file" accept="application/pdf" onChange={e => uploadFile(e.target.files[0].name, e.target.files[0], 'PatientenInfo')} /></p>
            </>
            <>
                <Heading level={3} style={{ textAlign: "center" }} padding={20}>Informationen für Mitarbeiter</Heading>
                <Table
                    caption={`${userDaten ? userDaten.length : 0} Datei${userDaten ? userDaten.length !== 1 ? 'en' : '' : 'en'} zum Herunterladen`}
                    highlightOnHover={true}
                    size='large'
                    variation='striped'
                >
                    <TableHead>
                        <TableRow>
                            <TableCell as="th">Datei</TableCell>
                            <TableCell as="th">vom</TableCell>
                            <TableCell as="th">Größe</TableCell>
                            <TableCell as="th"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {userDaten && userDaten.map((item, i) => {
                            const theDate = DatumToString(item.lastModified);
                            return (
                                <TableRow key={`r_${i}`}>
                                    <TableCell><Button gap="0.1rem" onClick={() => download(item.key)} size="large"><IconSave /> {item.key}</Button></TableCell>
                                    <TableCell>{theDate}</TableCell>
                                    <TableCell>{item.size}</TableCell>
                                    <TableCell><Button gap="0.1rem" onClick={() => deleteFile(item.key, 'public', 'MitarbeiterInfo')} size="large"><MdDeleteOutline /></Button></TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <p>In MitarbeiterInfo hochladen: <input type="file" accept="application/pdf" onChange={e => uploadFile(e.target.files[0].name, e.target.files[0], 'MitarbeiterInfo')} /></p>
            </>
        </Container>
    )
}

export default Uploads;
